// extracted by mini-css-extract-plugin
module.exports = {"Container":"EmptyLabel_Container__2FqpV","EmptyLabel":"EmptyLabel_EmptyLabel__1JLII"};